import { PropsWithChildren, useMemo } from "react";
import classnames from "classnames";

import Stack from "@/components/stack/stack";
import { WarningColor } from "@/features/shared/hooks/useHighestWarning";

import styles from "./tool.module.css";

interface ToolProps {
  variant?: WarningColor;
}

export default function Tool({
  variant,
  children,
  ...props
}: PropsWithChildren<ToolProps>) {
  const variantClass = useMemo(() => {
    if (variant && variant in styles) {
      return styles[variant];
    }
    return "";
  }, [variant]);

  return (
    <Stack
      gap={8}
      justifyContent="center"
      alignItems="center"
      className={classnames(styles.tool, variantClass)}
      {...props}
    >
      {children}
    </Stack>
  );
}
